import { concat, get, includes, isEmpty, map, toUpper, without } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getAvailableLocations } from '../../../redux/reducers/events'
import { setLocations } from '../../../redux/actions/setFilters'
import { enableLocationsFilterLabel } from '../../../configuration/configs'
import FilterPopoverWrapper from '../../elements/FilterPopoverWrapper'
import Checkbox from '../../elements/Checkbox'
import labels from '../../../configuration/labels'
import CaretDownIcon from '../../../assets/icons/caret-down.svg'

const LocationsFilter = () => {
  const activeLocations = useSelector(state => state.filtersData.locations)
  const availableLocations = useSelector(getAvailableLocations)
  const [currentFilters, setCurrentFilters] = useState(activeLocations)
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const dispatch = useDispatch()
  const isSmallScreen = window.innerWidth < 700

  useEffect(() => {
    setCurrentFilters(activeLocations)
    setIsActive(!isEmpty(activeLocations))
  }, [activeLocations])

  const togglePopover = () => {
    setIsPopoverOpen(status => !status)
  }

  const onToggleFilter = useCallback(
    event => {
      const filterId = get(event, 'target.id')

      if (filterId === 'All') {
        setCurrentFilters([])
      } else if (includes(currentFilters, filterId)) {
        setCurrentFilters(without(currentFilters, filterId))
      } else {
        setCurrentFilters(concat(currentFilters, filterId))
      }
    },
    [currentFilters]
  )

  const onSubmitFilters = useCallback(() => {
    dispatch(setLocations(currentFilters))
    setIsPopoverOpen(false)
  }, [dispatch, currentFilters])

  return (
    <div
      id="location-filter"
      className="decoupled-events__filters-bar-locations"
    >
      {enableLocationsFilterLabel && labels.filterLabelLocations && (
        <h4>{labels.filterLabelLocations}</h4>
      )}
      <FilterPopoverWrapper
        alignment={isSmallScreen ? 'end' : 'start'}
        containerParent="location-filter"
        popoverClassName="popover-location"
        isPopoverOpen={isPopoverOpen}
        onClosePopover={() => setIsPopoverOpen(false)}
        onSubmit={onSubmitFilters}
        PopoverTab={
          <button className={`filter-tab ${isActive ? 'active' : ''}`} onClick={togglePopover}>
            {toUpper(labels.filteredEventsLocation)}
            {!isEmpty(activeLocations) && <span>{`(${activeLocations.length})`}</span>}
            <img src={CaretDownIcon} alt={isPopoverOpen ? 'Close' : 'Open'} />
          </button>
        }
      >
        <Checkbox
          key="All"
          id="All"
          label="All"
          onChange={onToggleFilter}
          value={isEmpty(currentFilters)}
        />
        {map(availableLocations, availableLocation => (
          <Checkbox
            key={availableLocation}
            id={availableLocation}
            label={availableLocation}
            onChange={onToggleFilter}
            value={includes(currentFilters, availableLocation)}
          />
        ))}
      </FilterPopoverWrapper>
    </div>
  )
}

export default LocationsFilter
